import { AppConfigService } from '@/services/config'

/**
 * Get the base URL for Logto callback (redirect URI).
 * Use VITE_APP_URL when behind proxy/CDN where window.location.origin may differ from public URL.
 * Must match exactly what is configured in Logto Console > Redirect URIs.
 */
export function getCallbackBaseUrl(): string {
  const configured = AppConfigService.getString('VITE_APP_URL') || AppConfigService.getString('PUBLIC_APP_URL')
  if (configured && configured.trim()) {
    return configured.replace(/\/$/, '') // strip trailing slash
  }
  return typeof window !== 'undefined' ? window.location.origin : ''
}

export const LOGTO_CALLBACK_PATH = '/app/callback'
export const POST_AUTH_REDIRECT_KEY = 'logto:post_auth_redirect'
